import { IComponentOptions } from "angular";
import { ProcessTemplateController } from "./controller";
export const vsComponentName = "processTemplate";
export const ProcessTemplateComponentOptions: IComponentOptions =
{
  controller: ProcessTemplateController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    processTemplates: "<",
  },
};
